// extracted by mini-css-extract-plugin
export default {"small":"status_small__m36zc"};